import {setupI18n} from 'js-utils/i18n';
import context from './context';

/*
This destructuring is necessary in order to be able to setup the components
and then be able to export the functions once initialized. Doing something
such as `export setupI18n(context)` directly would have eslint complain
with an `import/named` error.
*/
export const {
    gettext,
    isPlural,
    lazyGettext,
    ngettext,
    normalizeLocale,
    setLanguage,
} = setupI18n(context);



// WEBPACK FOOTER //
// ./src/translations/index.js